import { FormlyFieldConfig } from '@ngx-formly/core';

export function matAddonsExtension(field: FormlyFieldConfig) {
  if (
    !field.props ||
    (field.wrappers && field.wrappers.indexOf('mat-addons') !== -1)
  ) {
    return;
  }

  if (field.props.addonLeft || field.props.addonRight) {
    field.wrappers = [...(field.wrappers || []), 'mat-addons'];
  }
}
